// Hook de React Query pra listar usuários ativos (Story 11.4).
// Usado pelo picker de responsável no LeadForm e DealForm.
// Dados estáveis (equipe muda pouco) → staleTime alto.

import { useQuery } from '@tanstack/react-query';

import { fetchUsers, type UserPicker } from '../lib/users-api';

export const usersKeys = {
  all: ['users'] as const,
  list: () => [...usersKeys.all, 'list'] as const,
};

export function useUsers() {
  return useQuery<UserPicker[], Error>({
    queryKey: usersKeys.list(),
    queryFn: ({ signal }) => fetchUsers(signal),
    staleTime: 5 * 60_000, // equipe muda pouco — 5 min
  });
}
